<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Версия</label>
            <crm-input-text
              [(value)]="changelog.version"
              placeholder="1.0.0"
              [disabled]="canDelete"
              [isError]="$any(errors?.version)"></crm-input-text>
            <small
              *ngIf="errors?.version"
              class="p-error">
              {{ errors.version | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Дата публикации</label>
            <crm-datepicker
              [(value)]="changelog.publicationDate"
              [inputStyleClass]="errors?.publicationDate ? 'ng-invalid ng-dirty' : ''"
              [showTime]="true"
              [stepMinute]="5"></crm-datepicker>
            <small
              *ngIf="errors?.publicationDate"
              class="p-error">
              {{ errors.publicationDate | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Описание</label>
            <crm-editor
              [(value)]="changelog.description"
              height="300px"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Комментарий</label>
            <crm-editor
              [(value)]="changelog.shortSummary"
              height="110px"></crm-editor>
            <small
              *ngIf="errors?.shortSummary"
              class="p-error">
              {{ errors.shortSummary | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveChangelog()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteChangelog()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
